/* assets/armonia-collection.js
   <armonia-collection>: filtri (Search & Discovery) e ordinamento via Section Rendering API,
   pannelli mobile "Filtra" / "Ordina", slider prezzo, scorciatoie Tipo e "Carica altri capi".
   Senza JS: i filtri desktop si applicano con il bottone "Applica", "Carica altri capi" è un normale link
   alla pagina successiva. Nessuna libreria. */
(function () {
  'use strict';
  if (window.customElements && window.customElements.get('armonia-collection')) return;

  var SWAPS = ['head', 'bar', 'drawer-body', 'drawer-foot', 'sort-body', 'results', 'live'];
  var TIPO_PARAM = 'filter.p.product_type';

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function swapSel(name) { return '[data-armonia-swap="' + name + '"]'; }

  function formatPrice(euros) {
    var A = window.Armonia || {};
    var out = A.formatMoney ? A.formatMoney(euros * 100) : euros + ' €';
    return out.replace(/[.,]00(?=\D|$)/, '');
  }

  class ArmoniaCollection extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.sectionId = this.dataset.sectionId;
      this.abort = null;
      this.rangeTimer = null;
      this.openSheet = null;
      this.lastTrigger = null;

      this.watchHeader();

      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('input', this.onInput.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('submit', this.onSubmit.bind(this));
      this.addEventListener('toggle', this.onToggle.bind(this), true);

      this.onDocClick = this.onDocClick.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onPop = this.onPop.bind(this);
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);
      window.addEventListener('popstate', this.onPop);

      this.mq = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
      if (this.mq) {
        this.onMq = this.onMq.bind(this);
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('popstate', this.onPop);
      if (this.headerObserver) this.headerObserver.disconnect();
      document.documentElement.classList.remove('armonia-sheet-open');
    }

    /* ---------- Altezza dell'header (per la barra sticky) ---------- */
    watchHeader() {
      var header = document.querySelector('.armonia-header');
      if (!header) return;
      var set = function () {
        var h = header.getBoundingClientRect().height;
        if (h > 0) document.documentElement.style.setProperty('--armonia-header-h', h / 10 + 'rem');
      };
      set();
      window.addEventListener('resize', set);
      if ('ResizeObserver' in window) {
        this.headerObserver = new ResizeObserver(set);
        this.headerObserver.observe(header);
      }
    }

    /* ---------- Eventi ---------- */
    onChange(event) {
      var t = event.target;
      var form = t.closest && t.closest('form[data-armonia-form]');
      if (!form) return;
      var kind = form.getAttribute('data-armonia-form');

      if (kind === 'sort') {
        var value = t.value;
        this.apply(function (p) { p.set('sort_by', value); });
        if (this.openSheet) this.closeSheet(true);
        this.closeDropdowns();
        return;
      }

      if (t.hasAttribute('data-range-min') || t.hasAttribute('data-range-max')) {
        this.syncRange(t.closest('[data-armonia-range]'), t);
        clearTimeout(this.rangeTimer);
        this.rangeTimer = setTimeout(this.applyFilters.bind(this, form), 350);
        return;
      }
      this.applyFilters(form);
    }

    onInput(event) {
      var t = event.target;
      if (t.hasAttribute && (t.hasAttribute('data-range-min') || t.hasAttribute('data-range-max'))) {
        this.syncRange(t.closest('[data-armonia-range]'), t);
      }
    }

    onSubmit(event) {
      var form = event.target.closest && event.target.closest('form[data-armonia-form]');
      if (!form) return;
      event.preventDefault();
      if (form.getAttribute('data-armonia-form') === 'filters') this.applyFilters(form);
    }

    onClick(event) {
      var closer = event.target.closest ? event.target.closest('[data-armonia-close]') : null;
      if (closer) {
        event.preventDefault();
        this.closeSheet(closer.hasAttribute('data-armonia-show-results'));
        return;
      }
      var el = event.target.closest ? event.target.closest('a, button') : null;
      if (!el) return;

      var openName = el.getAttribute('data-armonia-open');
      if (openName) {
        event.preventDefault();
        this.open(openName, el);
        return;
      }
      if (el.hasAttribute('data-armonia-reset')) {
        event.preventDefault();
        this.apply(function (p) { ArmoniaCollection.clearFilters(p); });
        return;
      }
      if (el.hasAttribute('data-armonia-tipo') || el.hasAttribute('data-armonia-tipo-all')) {
        event.preventDefault();
        var value = el.getAttribute('data-armonia-tipo');
        var isOn = el.classList.contains('is-on');
        this.apply(function (p) {
          p.delete(TIPO_PARAM);
          if (value && !isOn) p.append(TIPO_PARAM, value);
        });
        return;
      }
      if (el.hasAttribute('data-armonia-more')) {
        event.preventDefault();
        this.loadMore(el);
      }
    }

    /* Un solo menu a tendina aperto alla volta */
    onToggle(event) {
      var d = event.target;
      if (!d.matches || !d.matches('details[data-armonia-dd]') || !d.open) return;
      qsa(this, 'details[data-armonia-dd][open]').forEach(function (other) {
        if (other !== d) other.open = false;
      });
    }

    onDocClick(event) {
      if (!this.contains(event.target) || !event.target.closest('details[data-armonia-dd]')) this.closeDropdowns();
    }

    onKey(event) {
      if (event.key === 'Escape') {
        if (this.openSheet) {
          this.closeSheet(false);
        } else {
          var open = qs(this, 'details[data-armonia-dd][open]');
          if (open) {
            open.open = false;
            var sum = qs(open, 'summary');
            if (sum) sum.focus();
          }
        }
        return;
      }
      if (event.key === 'Tab' && this.openSheet) this.trapFocus(event);
    }

    onPop() {
      this.fetchAndSwap(location.pathname + location.search, false);
    }

    onMq() {
      if (this.mq.matches && this.openSheet) this.closeSheet(false);
    }

    closeDropdowns() {
      qsa(this, 'details[data-armonia-dd][open]').forEach(function (d) { d.open = false; });
    }

    /* ---------- Slider prezzo ---------- */
    syncRange(box, changed) {
      if (!box) return;
      var min = qs(box, '[data-range-min]');
      var max = qs(box, '[data-range-max]');
      var top = Number(box.getAttribute('data-max')) || 1;
      var lo = Number(min.value);
      var hi = Number(max.value);
      if (lo > hi) {
        if (changed === min) { lo = hi; min.value = lo; } else { hi = lo; max.value = hi; }
      }
      box.style.setProperty('--lo', (lo * 100) / top);
      box.style.setProperty('--hi', (hi * 100) / top);
      var labelMin = qs(box, '[data-range-label-min]');
      var labelMax = qs(box, '[data-range-label-max]');
      if (labelMin) labelMin.textContent = formatPrice(lo);
      if (labelMax) labelMax.textContent = formatPrice(hi);
      /* quando le due maniglie si sovrappongono, quella spostata per ultima resta sopra */
      if (changed) {
        min.style.zIndex = changed === min ? 2 : 1;
        max.style.zIndex = changed === max ? 2 : 1;
      }
    }

    /* ---------- Parametri URL ---------- */
    static clearFilters(params) {
      Array.from(params.keys()).forEach(function (k) {
        if (k.indexOf('filter.') === 0) params.delete(k);
      });
    }

    applyFilters(form) {
      this.apply(function (p) {
        ArmoniaCollection.clearFilters(p);
        qsa(form, 'input[type="checkbox"]:checked:not(:disabled)').forEach(function (i) {
          if (i.name) p.append(i.name, i.value);
        });
        qsa(form, '[data-armonia-range]').forEach(function (box) {
          var top = Number(box.getAttribute('data-max')) || 0;
          var min = qs(box, '[data-range-min]');
          var max = qs(box, '[data-range-max]');
          if (Number(min.value) > 0) p.set(min.getAttribute('data-param'), min.value);
          if (Number(max.value) < top) p.set(max.getAttribute('data-param'), max.value);
        });
      });
    }

    apply(mutate) {
      var params = new URLSearchParams(location.search);
      params.delete('page');
      params.delete('section_id');
      mutate(params);
      var q = params.toString();
      this.fetchAndSwap(location.pathname + (q ? '?' + q : ''), true);
    }

    sectionUrl(url) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(this.sectionId);
    }

    /* ---------- Aggiornamento della pagina ---------- */
    fetchAndSwap(url, push) {
      var self = this;
      if (this.abort) this.abort.abort();
      this.abort = 'AbortController' in window ? new AbortController() : null;
      this.classList.add('is-loading');
      this.setAttribute('aria-busy', 'true');

      return fetch(this.sectionUrl(url), this.abort ? { signal: this.abort.signal } : undefined)
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          self.swap(doc);
          if (push) history.pushState({}, '', url);
          self.classList.remove('is-loading');
          self.removeAttribute('aria-busy');
          document.dispatchEvent(new CustomEvent('armonia:favorites-changed', { detail: {} }));
          document.dispatchEvent(new CustomEvent('armonia:collection-updated', { detail: { url: url } }));
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          self.classList.remove('is-loading');
          self.removeAttribute('aria-busy');
          /* ripiego: ricarico la pagina con i parametri scelti */
          window.location.href = url;
        });
    }

    swap(doc) {
      var self = this;
      var state = this.captureState();
      SWAPS.forEach(function (name) {
        var next = qs(doc, swapSel(name));
        var cur = qs(self, swapSel(name));
        if (next && cur) cur.replaceWith(next);
      });
      qsa(this, '[data-armonia-range]').forEach(function (box) { self.syncRange(box, null); });
      this.restoreState(state);
    }

    captureState() {
      var active = document.activeElement;
      var focusKey = null;
      if (active && this.contains(active) && active.matches && active.matches('input[type="checkbox"], input[type="radio"]')) {
        var scope = active.closest('[data-armonia-sheet]') ? 'sheet' : 'bar';
        focusKey = { name: active.name, value: active.value, scope: scope };
      }
      var body = qs(this, swapSel('drawer-body'));
      return {
        open: qsa(this, 'details[data-armonia-dd]').map(function (d) { return d.open; }),
        bodyScroll: body ? body.scrollTop : 0,
        focusKey: focusKey
      };
    }

    restoreState(state) {
      qsa(this, 'details[data-armonia-dd]').forEach(function (d, i) { if (state.open[i]) d.open = true; });
      var body = qs(this, swapSel('drawer-body'));
      if (body) body.scrollTop = state.bodyScroll;
      if (state.focusKey) {
        var key = state.focusKey;
        var root = key.scope === 'sheet' ? qs(this, '[data-armonia-sheet="filters"]') : qs(this, swapSel('bar'));
        var target = root && qsa(root, 'input').filter(function (i) { return i.name === key.name && i.value === key.value && !i.disabled; })[0];
        if (target) target.focus({ preventScroll: true });
      }
    }

    /* ---------- Carica altri capi ---------- */
    loadMore(link) {
      var self = this;
      var wrap = link.closest('[data-armonia-swap="more"]');
      var label = qs(link, '[data-armonia-more-label]') || link;
      var original = label.textContent;
      var loading = wrap && wrap.getAttribute('data-label-loading');
      var failed = wrap && wrap.getAttribute('data-label-error');
      var grid = qs(this, '[data-armonia-grid]');
      var href = link.getAttribute('href');
      if (!grid || !href) return;

      link.classList.add('is-busy');
      link.setAttribute('aria-disabled', 'true');
      if (loading) label.textContent = loading;
      var before = qsa(grid, '[data-armonia-item]').length;

      fetch(this.sectionUrl(href))
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = qsa(doc, '[data-armonia-grid] [data-armonia-item]');
          items.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
          ['seen', 'more'].forEach(function (name) {
            var next = qs(doc, swapSel(name));
            var cur = qs(self, swapSel(name));
            if (next && cur) cur.replaceWith(next);
            else if (!next && cur && name === 'more') cur.remove();
          });
          document.dispatchEvent(new CustomEvent('armonia:favorites-changed', { detail: {} }));
          var firstNew = qsa(grid, '[data-armonia-item]')[before];
          var focusable = firstNew && qs(firstNew, 'a[href]');
          if (focusable) focusable.focus({ preventScroll: true });
        })
        .catch(function () {
          link.classList.remove('is-busy');
          link.removeAttribute('aria-disabled');
          label.textContent = failed || original;
          setTimeout(function () { label.textContent = original; }, 3000);
        });
    }

    /* ---------- Pannelli mobile ---------- */
    open(name, trigger) {
      var sheet = qs(this, '[data-armonia-sheet="' + name + '"]');
      if (!sheet) return;
      this.closeDropdowns();
      this.openSheet = sheet;
      this.lastTrigger = trigger || null;
      sheet.classList.add('is-open');
      document.documentElement.classList.add('armonia-sheet-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      var closeBtn = qs(sheet, '.armonia-fsheet__close');
      if (closeBtn) setTimeout(function () { closeBtn.focus({ preventScroll: true }); }, 50);
    }

    closeSheet(scrollToResults) {
      var sheet = this.openSheet;
      if (!sheet) return;
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('armonia-sheet-open');
      this.openSheet = null;
      var trigger = this.lastTrigger;
      qsa(this, '[data-armonia-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
      else {
        var again = qs(this, '[data-armonia-open="' + (sheet.getAttribute('data-armonia-sheet')) + '"]');
        if (again) again.focus({ preventScroll: true });
      }
      if (scrollToResults) this.scrollToResults();
    }

    scrollToResults() {
      var res = qs(this, '[data-armonia-results]');
      var bar = qs(this, swapSel('bar'));
      if (!res) return;
      var offset = (bar ? bar.getBoundingClientRect().height : 0) + (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--armonia-header-h')) || 6) * 10 + 8;
      var top = res.getBoundingClientRect().top + window.pageYOffset - offset;
      if (top < window.pageYOffset) {
        window.scrollTo({ top: top, behavior: window.Armonia && window.Armonia.prefersReducedMotion && window.Armonia.prefersReducedMotion() ? 'auto' : 'smooth' });
      }
    }

    trapFocus(event) {
      var sheet = this.openSheet;
      var items = qsa(sheet, 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  }

  if (window.customElements) window.customElements.define('armonia-collection', ArmoniaCollection);
})();
